import React, { useState } from 'react'
import {
  Button,
  MainHeadline,
  PageWrapper,
  PageFooter,
  Flex,
} from '../../../styling/GlobalStyles'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { useNavigate } from 'react-router-dom'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Options } from 'components/Options/Options'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearInventoryItemsList,
  deleteInventoryItem,
  getInventoryItems,
} from 'features/inventory/inventoryItemsSlice'
import { AppDispatch, RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { setConfirmModal } from 'features/global/globalSlice'
import { getParams, handlePagination } from 'utils/helpers'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { ModalTypes } from 'types/global.interface'
import { Modal } from 'components/Modal/Modal'
import { InventoryLocationsModal } from 'components/Modal/InventoryLocationsModal'
import useQueryPagination from 'hooks/useQueryPagination'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'

export const InventoryItems = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { inventoryItems, totalPages } = useSelector(
    (store: RootState) => store.inventoryItems,
  )
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
  const [modal, setModal] = useState({ isOpen: false, locations: [], itemName: null })

  useQueryPagination({ fetchFunctions: [getInventoryItems], cleanUpFunctions: [clearInventoryItemsList], params })

  const handleDeleteItem = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteInventoryItem(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: inventoryItems.length < 2,
        },
        word: 'delete item',
      }),
    )
  }

  const filters = [

    {
      type: FilterEnum.ASYNC_SELECT,
      link: LinkEnum.INVENTORY_CATEGORIES,
      name: 'Category',
      state: null,
      single: true,
      propName: 'categoryId'
    }
  ]

  const columns: IHonestTableColumn<any>[] = [
    { id: 'name', header: 'Item Name', cell: (item) => item.name },
    { id: 'sku', header: 'SKU', cell: (item) => item.sku },
    { id: 'category', header: 'Category', cell: (item) => item.category.name },
    { id: 'minLevel', header: 'Min. Level', cell: (item) => item.minLevel },
    { id: 'maxLevel', header: 'Max Level', cell: (item) => item?.maxLevel },
    {
      id: 'actions',
      header: '',
      align: 'right',
      cell: (item) => (
        <span onClick={(e) => e.stopPropagation()}>
          <Options
            item={item}
            handleRemove={() => handleDeleteItem(item.id)}
            title='Inventory Item'
          />
        </span>
      ),
    },
  ]

  return (
    <>
      <NavBar
        defaultValue={params.q}
        input
        placeholder='Search Items...'
        setParams={setParams}
        filterOptions={filters}
        enableTemporaryManualClosing
      />
      <PageWrapper>
        <Flex width='100%' between mb='16' >
          <MainHeadline>Inventory Items</MainHeadline>
          <Button orange onClick={() => navigate('add')}>
            Add Item
          </Button>
        </Flex>

        {!inventoryItems.length ? (
          <NoItems title='Inventory Items' />
        ) : (
          <HonestTable columns={columns} data={inventoryItems} keyField='id' />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
      {modal.isOpen && (
        <Modal black>
          <InventoryLocationsModal locations={modal.locations} setModal={setModal} itemName={modal.itemName} />
        </Modal>
      )}
    </>
  )
}
